import React, { useContext, useEffect, useState } from 'react';

import Context from './index';
import { useQuery } from 'react-query';



const HomeProvider = (props) => {


    return (
        <Context.Provider
            value={{
            
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default HomeProvider;
